export default __webpack_public_path__ + "static/la-781b73e8f641b4ae5aaf710a0fce757b.svg";